import React, { useState } from "react";
import axios from "axios";

const ChatBox = () => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");

    const sendMessage = async () => {
        if (!input.trim()) return;

        const userMessage = { sender: "user", text: input };
        setMessages([...messages, userMessage]);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/question/`,
                {
                    question: input,
                }
            );
            const botMessage = { sender: "bot", text: response.data.message };
            setMessages((prevMessages) => [...prevMessages, botMessage]);
        } catch (error) {
            const errorMessage = {
                sender: "bot",
                text: "Error al procesar la solicitud.",
            };
            setMessages((prevMessages) => [...prevMessages, errorMessage]);
        }

        setInput("");
    };

    return (
        <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-800">
                Chat con la IA
            </h2>
            <div
                className="border border-gray-300 rounded-md p-4 mb-4 max-h-80 overflow-y-scroll"
                style={{ minHeight: "200px" }}
            >
                {messages.map((msg, index) => (
                    <div
                        key={index}
                        className={`mb-2 ${
                            msg.sender === "user" ? "text-right" : "text-left"
                        }`}
                    >
                        <p
                            className={`inline-block px-4 py-2 rounded-lg ${
                                msg.sender === "user"
                                    ? "bg-blue-500 text-white"
                                    : "bg-gray-200 text-gray-800"
                            }`}
                        >
                            {msg.text}
                        </p>
                    </div>
                ))}
            </div>
            <div className="flex">
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Escribe tu pregunta..."
                    className="flex-grow border border-gray-300 rounded-l-md px-4 py-2"
                />
                <button
                    onClick={sendMessage}
                    className="bg-blue-500 text-white px-6 py-2 rounded-r-md hover:bg-blue-600"
                >
                    Enviar
                </button>
            </div>
        </div>
    );
};

export default ChatBox;
